import * as OpenMeto from './open-meteo';
import { GeoLocation, Timestamped, WindDataPoint } from './types';
import { Interval, intervalToMs } from 'ixfx/flow';
import { Arrays } from 'ixfx/data';

export function getFallbackData(): WindDataPoint[] {
  const data = OpenMeto.fetchFallbackData();
  return OpenMeto.processData(data);
}

export async function getData(location: GeoLocation): Promise<WindDataPoint[]> {
  const data = await OpenMeto.fetchData(location);
  return OpenMeto.processData(data);
}

export function segmentByPeriod<T extends Timestamped>(interval: Interval, data: T[]) {
  const periods: T[][] = [];
  const ms = intervalToMs(interval);
  let current = 0;
  let currentPeriod: T[] = [];

  for (let i = 0; i < data.length; i++) {
    if (i === 0) current = data[ i ].time;
    else {
      const abs = Math.abs(data[ i ].time - current);
      if (abs >= ms) {
        currentPeriod = [];
        periods.push(currentPeriod);
        current = data[ i ].time;
      } else {
        currentPeriod.push(data[ i ]);
      }
    }
  }
  return periods;
}